module.exports = __webpack_public_path__ + "static/media/external-link-icon-grey.154d1174.svg";